import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#101524', // Dark background
      paper: '#2b2d31',   // Slightly lighter for elements like sidebar, input
      sidebar: '#0C101C',
      sender: '#1D2439',
      suggestion: '#171E32',
      suggestionHover: '#2b2d31',
      suggestionBorder: '#2b2d31',
      chatBorder: '#24293a',
    },
    primary: {
      main: '#8a84ff', // Accent color (adjust as needed)
    },
    text: {
      primary: '#ffffff',
      secondary: '#b5bac1',
    },
  },
  typography: {
    fontFamily: 'var(--inter-font)',
    body1: {
      fontSize: '0.9rem',
    },
    body2: {
      fontSize: '0.8rem',
    },
    button: {
      textTransform: 'none', // Buttons usually don't have uppercase text in Copilot
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px', // Rounded buttons
        },
      },
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                backgroundImage: 'none', // Ensure paper components don't have gradients unless specified
            }
        }
    }
  },
});

export default theme;